import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-forward",
  "use": "arrow-forward-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"arrow-forward\"><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.72.47a.75.75 0 011.06 0l3.75 3.75a.75.75 0 010 1.06L9.78 9.03a.75.75 0 01-1.06-1.06l3.22-3.22-3.22-3.22a.75.75 0 010-1.06z\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 5.5a2.25 2.25 0 00-2.25 2.25V13a.75.75 0 01-1.5 0V7.75A3.75 3.75 0 014 4h9a.75.75 0 010 1.5H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol